import React from 'react';
import AnalyticsPageLayout from '../components/analytics/AnalyticsPageLayout';
import Spinner from '../components/spinner/Spinner';
import { LineGraph } from '../components/charts/LineGraph';
import useFetchAnalytics from '../hooks/useFetchAnalytics';

// Moved off the home dashboard. Still served by the legacy GET /analytics/api/
// endpoint; the recording bug behind the flat-zero data is being fixed server-side.
function AdminLoginsAnalytics() {
  const { data: analyticsData, isLoading } = useFetchAnalytics(
    ['dashboard-analytics'],
    '/',
    {},
    "Couldn't fetch data. Please try again!",
    true
  );

  const loginData = analyticsData?.data?.graphs_data?.find(
    (graph) => graph.title === 'admins daily logins'
  );

  return (
    <AnalyticsPageLayout
      title="Administrator Daily Logins"
      description="Daily login counts for staff accounts."
    >
      {isLoading ? (
        <div className="flex items-center justify-center bg-white rounded-xl border border-gray-200 shadow-sm py-10">
          <Spinner />
        </div>
      ) : (
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-4">
          <LineGraph
            title="Administrator Daily Logins"
            colour="#8b173b"
            datasets={loginData?.datasets || []}
            labels={loginData?.labels || []}
            label="Number of Administrators"
          />
        </div>
      )}
    </AnalyticsPageLayout>
  );
}

export default AdminLoginsAnalytics;
